<question-wrapper [title]="title">
  <div
    class="ic-question-number__answer"
    [ngClass]="{
      'ic-question-number__answer--out-of-bounds': isOutOfBounds,
      'ic-question-number__answer--invalid': isEmpty
    }"
  >
    <input
      class="input"
      type="number"
      [ngClass]="{ invalid: isEmpty, warning: isOutOfBounds }"
      placeholder="{{ getPlaceholder() }}"
      min="{{ minValue }}"
      max="{{ maxValue }}"
      [(ngModel)]="value"
      (ngModelChange)="validateAnswer()"
      (change)="onValueChange()"
    />
    @if (isOutOfBounds) {
    <div class="ic-question-number_warning">
      <div class="warning-container">
        <div class="warning-image-container">
          <img src="/assets/images/info-icon-blue.png" />
        </div>
        <div class="warning-msg-container">
          <div>Your parameter is out of range ({{ minValue }}-{{ maxValue }}).</div>
          Do you have a reason to leave it as it is?
        </div>
      </div>
    </div>
    } @if (isEmpty) {
    <div class="ic-question-number_error">this is mandatory field</div>
    }
  </div>
</question-wrapper>
